import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "./Dropdown";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets-fixed";
import axios from "axios";
import { PriceChart } from "./chart/priceChart";
import { useTranslation } from "react-i18next";

const ScheduleWrapper = ({ frame, chartContent, buyOrderComponent }) => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [ordersAsks, setOrdersAsks] = useState([]);

  function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return "" + Math.round(n * k) / k;
      };
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }

  // настройки нового ордера

  const handleGetOrders = () => {
    let stockName = match[1];

    axios
      .get(
        `https://api-ru.fynex.cc/api/api/share/get_orderbook?limit=12&name=${stockName}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setOrdersAsks(res.data.data.asks);
        // console.log(res.data.data.asks);


        setOrders(res.data.data.bids);
        // setTimeout(() => handleGetOrders(), 7000);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const averagePrice = 67325; // Пример средней цены

    // настройки нового ордера
    const [price, setPrice] = useState("")
    const [priceSell, setPriceSell] = useState("")
    const [price2, setPrice2] = useState("")
    const [priceSell2, setPriceSell2] = useState("")
    const [isLoadedOrders, setIsLoadedOrders] = useState(false);

    const url = new URL(document.location.href);
    let symbolMarket = (url.searchParams.get('symbol'));
    let match = symbolMarket.match(/(\w+)(USDT|RUB|USD)/);
    const [AVG, setAVG] = useState("");

    const token = localStorage.getItem("token");

    const [ menuSelection, setMenuSelection ] = useState(1);
    // const requireAVGdata = () => axios.get(`https://api.binance.com/api/v3/ticker/24hr?symbol=${symbolMarket}`)
    //     .then(res => {
    //         setAVG(res.data.lastPrice);
    //     })
    // const requireOrders = () => axios.get(`https://api.binance.com/api/v3/depth?limit=7&symbol=${symbolMarket}`)
    //     .then(order => {
    //         setOrdersAsks(order.data.asks);
    //         setOrders(order.data.bids);
    //         setIsLoadedOrders(true);
    //         setPrice(order.data.asks[0][0])
    //         setPriceSell(order.data.bids[0][0])
    //         setPrice2(order.data.asks[0][0])
    //         setPriceSell2(order.data.bids[0][0])
    //     })

    const requireAVGdata = () => axios.get(`https://api-ru.fynex.cc/api/api/share/get_avg?symbol=${match[1]}`)
        .then(res => {
            setAVG(res.data.lastPrice);
            setTimeout(() => requireAVGdata(), 20000)
        })
        .catch((err) => {console.error(err)})
    const handleOrderBook = () => {
        let stockName = match[1]
        axios.get(`https://api-ru.fynex.cc/api/api/share/get_orderbook?name=${stockName}&limit=12`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(res => {
                setOrdersAsks(res.data.data.asks);
                setOrders(res.data.data.bids);
                setPrice(res.data.data.asks[0][0])
                setPriceSell(res.data.data.bids[0][0])
                setPrice2(res.data.data.asks[0][0])
                setPriceSell2(res.data.data.bids[0][0])
                setIsLoadedOrders(true);
            })
            .catch((err) => {console.error(err)})
    }

    // const handleGetOrders = () => {
    //     let stockName = match[1]

    //     axios.get(`https://api-ru.fynex.cc/api/api/share/get_orderbook?name=${stockName}&limit=12`, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${token}`
    //         }
    //     })
    //         .then(res => {
    //             setOrdersAsks(res.data.data.asks.slice(0, 7));
    //             console.log(res.data.data.asks);
                
    //             setOrders(res.data.data.bids.slice(0, 7));
    //             setTimeout( () => handleGetOrders(), 7000)
    //         })
    //         .catch((err) => {console.error(err)})
    // }


  const getColorClass = (value) => (value < 0 ? "text-danger" : "text-success");

  useEffect(() => {
    setInterval(() => {
      handleGetOrders();
      requireAVGdata();
    }, 1000);
  }, []);

  const generateBackgroundTable = (order) => {
    console.log(orders);
  };
  const [linearGradient, setLinearGradient] = useState([
    "100",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
  ]);
  const [linearGradient2, setLinearGradient2] = useState([
    "100",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
  ]);

  // useEffect(() => {
  //     setTimeout(() => {
  //         const element = document.querySelector('.react-financial-charts');
  //         if (element) {
  //             element.style.zIndex = '1';
  //             console.log('z-index изменён на 1');
  //         } else {
  //             console.log('Элемент с классом react-financial-charts не найден');
  //         }
  //     }, 2500)
  // }, [])

  function convectator(value, in_min, in_max, out_min, out_max) {
    return (
      ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  }

  const sumUSDT = (priceUSDT, countBTC) => {
    let sum = String(Number(priceUSDT) * Number(countBTC));
    sum = number_format(sum, 2);
    // if(sum.length > 5) sum.length = 5
    // console.log(sum);
    return sum;
  };
  // console.log("====================================");
  // console.log(orders);
  // console.log("====================================");
  useEffect(() => {
    const tmp = [...linearGradient];
    const tmp2 = [...linearGradient2];

    const ordersCountList = orders.map((item) => Number(item[1]));
    const ordersCountList2 = ordersAsks.map((item) => Number(item[1]));

    ordersCountList.forEach((item, idx) => {
      tmp[idx] = convectator(
        item,
        Math.min(...ordersCountList),
        Math.max(...ordersCountList),
        0,
        100
      );
    });
    ordersCountList2.forEach((item, idx) => {
      tmp2[idx] = convectator(
        item,
        Math.min(...ordersCountList2),
        Math.max(...ordersCountList2),
        0,
        100
      );
    });
    setLinearGradient(tmp);
    setLinearGradient2(tmp2);
  }, [orders]);

  return (
    <div className="schedule-wrapper">
      <div className="schedule">
        <div
          className={
            menuSelection == 2
              ? "wrapper-menu wrapper-menu-active"
              : "wrapper-menu"
          }
        >
          <div className="schedule-block">
            <PriceChart />
          </div>
          <div className="OrderGlass">
            <table>
              <thead>
                <tr>
                  <th>{t("schedule.price_usdt")}</th>
                  <th>{t("schedule.quantity_btc")}</th>
                  <th>{t("schedule.sum_usdt")}</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order, index) => (
                  <tr
                    style={{
                      background: `linear-gradient(-90deg, rgba(32, 172, 149, 0.2) ${linearGradient[index]}%, rgba(255,255,255,0) ${linearGradient[index]}%)`,
                    }}
                  >
                    <div className="price plus">
                      {order[0].toLocaleString()}
                    </div>
                    <div>{order[1].toLocaleString()}</div>
                    <div>{sumUSDT(order[0], order[1])}</div>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="average-price">
              <h2 className={getColorClass(averagePrice)}>
                {AVG.toLocaleString()}
              </h2>
            </div>

            <table>
              <tbody>
                {ordersAsks.map((order, index) => (
                  <tr
                    key={`bottom-${index}`}
                    style={{
                      background: `linear-gradient(-90deg, rgba(226, 70, 74, 0.2) ${linearGradient2[index]}%, rgba(255,255,255,0) ${linearGradient2[index]}%)`,
                    }}
                  >
                    <div
                      style={{ background: `transparent !important` }}
                      className="price minus"
                    >
                      {order[0].toLocaleString()}
                    </div>
                    <div style={{ background: `transparent !important` }}>
                      {order[1].toLocaleString()}
                    </div>
                    <div style={{ background: `transparent !important` }}>
                      {sumUSDT(order[0], order[1])}
                    </div>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {buyOrderComponent}
        </div>
      </div>
    </div>
  );
};

export default ScheduleWrapper;